export const EMERGENCY_NOTICE_STRINGS = {
    Call911:
        'If you think you may have a medical emergency, ' +
        'please call 911 or your local emergency telephone number.',
};
